import React from "react";
import { ContactButtons } from "./ContactButtons";
import { ShieldCheck, Star } from "lucide-react";

const PageHero = ({ eyebrow, title, subtitle, image, children, badges = true }) => {
  return (
    <section className="relative bg-brand-navy text-white pt-16 lg:pt-24 pb-16 lg:pb-24 overflow-hidden">
      {/* Background image with Ken Burns animation */}
      {image && (
        <div className="absolute inset-0 overflow-hidden">
          <div
            className="absolute inset-0 ken-burns"
            style={{
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        </div>
      )}

      {/* Multi-layer overlay for premium feel */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-navy-dark/85 via-brand-navy/70 to-brand-navy/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/80 via-transparent to-transparent" />

      {/* Decorative grid */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {badges && (
          <div className="flex flex-wrap items-center gap-2 mb-6">
            <span className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur border border-white/20 rounded-full px-3 py-1.5">
              <ShieldCheck className="h-3.5 w-3.5 text-brand-blue-light" />
              <span className="text-[10px] font-bold tracking-widest uppercase text-brand-blue-light">
                Gas Safe Registered
              </span>
            </span>
            <span className="inline-flex items-center gap-1 bg-amber-400/15 backdrop-blur border border-amber-300/30 rounded-full px-3 py-1.5">
              <Star className="h-3 w-3 fill-amber-300 text-amber-300" />
              <span className="text-[10px] font-bold tracking-wider text-amber-200">
                5.0 RATED
              </span>
            </span>
            {eyebrow && (
              <span className="inline-flex items-center gap-1.5 bg-brand-blue/20 backdrop-blur border border-brand-blue/30 rounded-full px-3 py-1.5">
                <span className="text-[10px] font-bold tracking-widest uppercase text-white">
                  {eyebrow}
                </span>
              </span>
            )}
          </div>
        )}
        <h1
          data-testid="page-h1"
          className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black tracking-tight max-w-4xl leading-[1.05] mb-5"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-base sm:text-lg text-slate-200 max-w-3xl leading-relaxed mb-7">
            {subtitle}
          </p>
        )}
        {children}
        <div className="mt-7">
          <ContactButtons />
        </div>
      </div>
    </section>
  );
};

export default PageHero;
